import * as React from 'react';
import { Oval } from 'react-loader-spinner';
import { Box } from '@mui/system';
import { useTheme } from '@mui/material';

var Loader = function (_a) {
    var _b = _a.width, width = _b === void 0 ? 40 : _b, _c = _a.height, height = _c === void 0 ? 40 : _c;
    var palette = useTheme().palette;
    return (React.createElement(Oval, { wrapperClass: "simple-loader", width: width + "px", height: height + "px", color: palette.contrasting, secondaryColor: palette.contrasting + "33", ariaLabel: "Loading..." }));
};
var CenteredLoader = function (_a) {
    var _b = _a.width, width = _b === void 0 ? 40 : _b, _c = _a.height, height = _c === void 0 ? 40 : _c;
    return (React.createElement(Box, { className: "centered-loader-wrapper", sx: {
            display: "flex",
            padding: "8em 0",
            alignItems: "center",
            justifyContent: "center",
        } },
        React.createElement(Loader, { width: width, height: height })));
};

export { CenteredLoader, Loader };
